module.exports = __webpack_public_path__ + "media/images/page/labo-02-e908b30f6e8aa1b66085a6e92993ea80.webp";